<template>
  <div class="card-verification-details page-container">
    <div class="page-title">
      {{ $t('customerService.card_verification_search') }}
    </div>
    <div class="filter-section-container">
      <div class="filter-fixed">
        <span class="filter-fixed-title">{{ $t('data.filter_section') }}</span>
        <i
          class="el-icon-arrow-down filter-fixed-arrow"
          :class="{'fiter-icon-arrow-route':!showFilterContent}"
          @click="onClickFixedArrow"
        />
      </div>
      <el-collapse-transition>
        <div v-show="showFilterContent">
          <div id="filter-content" class="filter-content">

            <div class="filter-item">
              <div class="filter-item-label">{{ $t('data.merchant_order_id') }}</div>
              <el-input
                v-model="search.mch_order_id"
                size="small"
                type="text"
                maxlength="32"
                class="filter-item-value"
                clearable
              />
            </div>

            <div class="filter-item">
              <div class="filter-item-label">{{ $t('data.transaction_id') }}</div>
              <el-input
                v-model="search.transaction_id"
                size="small"
                type="text"
                maxlength="32"
                class="filter-item-value"
                clearable
              />
            </div>
            <div class="filter-item">
            </div>

          </div>
          <div class="filter-operate">
            <div class="filter-operate-left">
            </div>
            <div class="filter-operate-right">
              <el-button class="search-btn mb-10" size="small" @click="onClickReset">{{ $t('components.clear') }}</el-button>
              <el-button class="search-btn mb-10" type="primary" size="small" icon="el-icon-search" @click="handleFilter">{{ $t('components.search') }}</el-button>
            </div>
          </div>
        </div>
      </el-collapse-transition>
    </div>

    <div class="tableContainer">
      <el-table
        v-loading="listLoading"
        :data="tableData"
        stripe
        fit
        highlight-current-row
        style="width: 100%"
      >
        <el-table-column :label="$t('data.transaction_id')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.transaction_id }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.merchant_order_id')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.merchant_order_id }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.account_no')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.account_no }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.account_bank_code')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.account_bank_code }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.account_name')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.account_name }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.account_status')" align="center" min-width="110">
          <template slot-scope="scope">
            <el-tag class="tag-custom" :type="getAccountStatusType(scope.row.account_validate_result)">{{ getAccountStatusLabel(scope.row.account_validate_result) }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.order_status')" align="center" min-width="160">
          <template slot-scope="scope">
            <el-tag class="tag-custom" :type="getTransactionStatusType(scope.row.transaction_status)">{{ getTransactionStatusLabel(scope.row.transaction_status) }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.name_match_result')" align="center" min-width="120">
          <template slot-scope="scope">
            <el-tag class="tag-custom" :type="getNameMatchResultType(scope.row.name_match_result)">{{ getNameMatchResultLabel(scope.row.name_match_result) }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.account_actual_type')" align="center">
          <template slot-scope="scope">
            <span>{{ getAccountTypeLabel(scope.row.real_account_type) || '-' }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.account_kyc_result')" align="center" min-width="110">
          <template slot-scope="scope">
            <span>{{ getAccountKycResultLabel(scope.row.account_kyc_result) }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('dashboard.fee')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.fee_split | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column width="105" :label="$t('merchantAccount.create_time')" align="center">
          <template slot-scope="scope">
            {{ scope.row.transaction_create_time }}
          </template>
        </el-table-column>

        <el-table-column width="105" :label="$t('merchantAccount.complete_time')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.transaction_return_time || '-' }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('components.operation')" align="center" min-width="80">
          <template slot-scope="scope">
            <el-tooltip placement="top">
              <div slot="content">
                <span> {{ $t('components.detail') }}</span> <br>
              </div>
              <svg-icon class-name="icon-function" icon-class="operation-detail" @click="onClickDetailTxt(scope.row)" />
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <paginator v-if="!listLoading" :list-query="listQuery" @paginator-change="onClickPaginator" />
      </div>
    </div>

    <CardVerificationDetailModal
      ref="cardVerificationDetailModal"
      :visible.sync="detailModalVisible"
    />
  </div>
</template>

<script>
import { fetchCardVerificationList } from '@/api/data/data'
import { filterEmptyAttr, exportXlsx } from '@/utils/common'
import CardVerificationDetailModal from '../data/components/Modal/CardVerificationDetailModal.vue'
import {
  accountNameMatchResultMap,
  accountTypeMap,
  accountValidateResultMap,
  accountKycResultMap,
  cardValidationStatusMap
} from '@/utils/maps'

export default {
  name: 'Card_Verification_Details',
  components: {
    Paginator: () => import('@/views/components/Paginator'),
    CardVerificationDetailModal
  },
  data() {
    return {
      showFilterContent: true,
      search: {
        mch_order_id: '',
        transaction_id: ''
      },
      tableData: [],
      total_count: 0,
      total_fee: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      },
      downloading: false,
      detailModalVisible: false
    }
  },
  computed: {
    getAccountTypeLabel() {
      return function(value) {
        return accountTypeMap(value)?.label || '-'
      }
    },
    getAccountStatusType() {
      return function(value) {
        return accountValidateResultMap(value)?.type || 'info'
      }
    },
    getAccountStatusLabel() {
      return function(value) {
        return accountValidateResultMap(value)?.label || '-'
      }
    },
    getTransactionStatusType() {
      return function(value) {
        return cardValidationStatusMap(value)?.type || 'info'
      }
    },
    getTransactionStatusLabel() {
      return function(value) {
        return cardValidationStatusMap(value)?.label || '-'
      }
    },
    getNameMatchResultType() {
      return function(value) {
        return accountNameMatchResultMap(value)?.type || 'info'
      }
    },
    getNameMatchResultLabel() {
      return function(value) {
        return accountNameMatchResultMap(value)?.label || '-'
      }
    },
    getAccountKycResultLabel() {
      return function(value) {
        return accountKycResultMap(value)?.label || '-'
      }
    }
  },
  created() {
    // this.handleFilter()
  },
  methods: {
    getCardValidationList(params) {
      this.listLoading = true
      fetchCardVerificationList(params).then(res => {
        const { total = 0, list = [] } = res.data || {}
        this.listQuery.total = total
        this.listQuery.page = params.page ? params.page : 1
        this.tableData = list
      }).finally(() => {
        this.listLoading = false
      })
    },
    getParams(otherParams = {}) {
      const { mch_order_id, transaction_id } = this.search
      let params = {
        mch_order_id,
        transaction_id,
        is_search_count: true,
        ...otherParams
      }
      params = filterEmptyAttr(params)
      return params
    },
    handleFilter(otherParams = {}) {
      const params = this.getParams(otherParams)
      if (!params) {
        return
      }
      this.getCardValidationList(params)
    },
    onClickFixedArrow() {
      this.showFilterContent = !this.showFilterContent
    },
    onClickReset() {
      this.search = {
        mch_order_id: '',
        transaction_id: ''
      }
    },
    onClickPaginator() {
      this.handleFilter(this.listQuery)
    },
    onClickDetailTxt(row) {
      this.$refs.cardVerificationDetailModal.changModalStatus(true, row.transaction_id)
    }
  }
}
</script>

<style lang="scss" scoped>
.card-verification-details_popover_title{
  text-align: center;
  color: #606266;
}
.card-verification-details_textarea{
  margin-bottom: 20px;
}
.card-verification-details_btn-container{
  margin: 0 50px;
  display: flex;
  justify-content: space-between;
}
.card-verification-details_size-btn{
  width: 80px;
  height: 28px;
  line-height: 6px;
}
.card-verification-details{
  margin: 20px;
  background: #fff;
  border-radius: 4px;
  .pagination-container{
    padding: 20px;
    margin-top: 0;
  }
  .filter-container{
    padding: 40px 0 24px 24px;
  }

  .search-frame {
    width: 256px;
    margin-bottom: 10px;
    margin-right: 5px;
  }
  // .search-btn {
  //   margin-left: 10px;
  // }
  .tag-status{
    // text-decoration: underline;
    // cursor: pointer;
  }
}
</style>
